module.exports = __webpack_public_path__ + "static/media/B3C403FD-89BD-4C84-80EA-C5A0135A0C11.e9712461.JPG";